/* Copyright (c) 2017 Backpack Health LLC */

/* global window */

import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { AppNavCancelButton } from '../../../components/appNav/appNavBits/AppNavButtons';
import { PreferredLanguageDropdownList } from '../../../components/LanguageDropdownList';
import PrivacyIntroContent from './PrivacyIntroContent';
import COLORS from '../../../styles/Colors';

function mapStateToProps() {
  return {
    baseColor: COLORS.bcBackpackRedHighlight,
    darkAccentColor: COLORS.bcBackpackRedAccent,
  };
}

interface Props {
  baseColor: string;
  darkAccentColor: string;
  onAccept(): void;
  loadInitialData?(): void;
  goToContactUs(): void;
  onCancel(): void;
  showLanguageControl: boolean;
  isNewUser: boolean;
}

interface State {
  isScrolled: boolean;
}

class PrivacyIntro extends React.Component {
  props: Props;

  state: State = {
    isScrolled: false,
  };

  UNSAFE_componentWillMount() {
    const { loadInitialData } = this.props;
    if (loadInitialData) { loadInitialData(); }

    window.addEventListener('resize', this.toggleIsScrolled);
    window.addEventListener('scroll', this.toggleIsScrolled);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.toggleIsScrolled);
    window.removeEventListener('scroll', this.toggleIsScrolled);
  }

  toggleIsScrolled = () => {
    if (window.scrollY > 10) {
      if (!this.state.isScrolled) {
        this.setState({ isScrolled: true });
      }
    } else if (this.state.isScrolled) {
      this.setState({ isScrolled: false });
    }
  }

  render() {
    const { baseColor, darkAccentColor, onCancel, showLanguageControl, isNewUser, onAccept } = this.props;

    return (
      <div
        className={classnames('cmp-privacyintro', { scrolled: this.state.isScrolled })}
        style={{
          background: `linear-gradient(150.49deg, ${baseColor} 0.51%, ${darkAccentColor} 100%)`,
          minHeight: '100%',
          paddingBottom: 12,
        }}
      >
        <header className="util-application-frame-nocards-padding">
          <AppNavCancelButton color="white" onClick={onCancel} />

          {
            showLanguageControl && (
              <PreferredLanguageDropdownList htmlId="userLanguage" color="white" />
            )
          }
        </header>
        <div style={{ paddingTop: 64 }} />
        <PrivacyIntroContent onAccept={onAccept} isNewUser={isNewUser} />
      </div>
    );
  }
}

export default connect(mapStateToProps)(PrivacyIntro);
